module.exports = __webpack_public_path__ + "dd72411ca6d8a90a0d13063aad77c75a.pdf";